import Jsona from "jsona";

import http from "../api/http";

import config from "../../config";
import { promoCodesActions } from "../slices/promocodes-slice";

export const fetchPromoCodes = (userId) => {
  const apiBaseUrl =
    config.REACT_APP_IDENTITY_BASE_URL +
    config.REACT_APP_PROMOCODES_LISTINGS_URI.replace(":userId", userId);

  const params = {
    params: { filter: { isredeemed: false, isexpired: false } },
  };

  const request = http.get(apiBaseUrl, params);

  return (dispatch) => {
    dispatch(
      promoCodesActions.setLoading({
        isLoading: true,
        willClearError: true,
      })
    );

    return request.then(
      ({ data }) => {
        const discountCodes = new Jsona().deserialize(data);

        dispatch(promoCodesActions.setDiscountCodes(discountCodes));
      },
      (error) => {
        let errorMessage = config.generalError;

        try {
          if (error.messages && typeof error.messages === "string") {
            errorMessage = error.messages;
          } else if (
            error.response.data.message &&
            typeof error.response.data.message === "string"
          ) {
            errorMessage = error.response.data.message;
          } else if (
            error.response.data.errors.message &&
            typeof error.response.data.errors.message === "string"
          ) {
            errorMessage = error.response.data.errors.message;
          }
        } catch {
          console.log("error.response: ", error.response);
          console.log("error.request: ", error.request);
          console.log("error.config: ", error.config);
          if (error.response) {
            errorMessage = "Fetch purposes failed!";
          }
        }

        console.log("Listing fetchPurposes error: " + errorMessage);

        dispatch(promoCodesActions.setError(errorMessage));
      }
    );
  };
};

export const validatePromoCode = (userId, promoCode, callback) => {
  const apiBaseUrl =
    config.REACT_APP_IDENTITY_BASE_URL +
    config.REACT_APP_PROMOCODES_LISTINGS_URI.replace(":userId", userId);

  const params = {
    params: { filter: { isredeemed: false, isexpired: false } },
  };

  const request = http.get(apiBaseUrl, params);

  return (dispatch) => {
    dispatch(
      promoCodesActions.setLoading({
        isLoading: true,
        willClearError: true,
      })
    );

    return request.then(
      ({ data }) => {
        const promoCodes = new Jsona().deserialize(data);
        const isPromoCodeValid = promoCodes.some((promoObj) => {
          return promoObj?.promoCode === promoCode;
        })

        dispatch(promoCodesActions.setDiscountCodes(promoCodes));
        if(callback){
          callback(isPromoCodeValid);
        }
      },
      (error) => {
        let errorMessage = config.generalError;

        try {
          if (error.messages && typeof error.messages === "string") {
            errorMessage = error.messages;
          } else if (
            error.response.data.message &&
            typeof error.response.data.message === "string"
          ) {
            errorMessage = error.response.data.message;
          } else if (
            error.response.data.errors.message &&
            typeof error.response.data.errors.message === "string"
          ) {
            errorMessage = error.response.data.errors.message;
          }
        } catch {
          console.log("error.response: ", error.response);
          console.log("error.request: ", error.request);
          console.log("error.config: ", error.config);
          if (error.response) {
            errorMessage = "Fetch purposes failed!";
          }
        }

        console.log("Listing fetchPurposes error: " + errorMessage);

        dispatch(promoCodesActions.setError(errorMessage));
      }
    );
  };
};

export const clearDiscountCodes = () => {
  return (dispatch) => {
    dispatch(promoCodesActions.resetDiscountCodes());
  };
};
